import { stage, trackWithDefaultStage } from "@flights/et-universal";
import { BLACK_FRIDAY_EXLUDED_COUNTRIES } from "../../../constants";
import { isOfMetaOrigin, isOfPPCOrigin } from "../../../utils/marketing-url-params";
import useGlobalContext from "../../../hooks/useGlobalContext";
import useProfiler from "../../../hooks/useProfiler";
import useRouteName from "../../../hooks/useRouteName";

const useBlackFridayExp = (): boolean => {
  const { ipCountry = "" } = useGlobalContext();
  const { isDesktop } = useProfiler();
  const routeName = useRouteName();

  const isBlackFridayEligible =
    !isOfPPCOrigin() && !isOfMetaOrigin() && !BLACK_FRIDAY_EXLUDED_COUNTRIES.includes(ipCountry.toLowerCase());

  const isBlackFridayExp =
    isBlackFridayEligible && !!trackWithDefaultStage("flights_web_cat_black_friday_index_2025", 1);

  if (isDesktop() && isBlackFridayEligible) {
    stage("flights_web_cat_black_friday_index_2025", 2);
  }

  if (!isDesktop() && isBlackFridayEligible) {
    stage("flights_web_cat_black_friday_index_2025", 3);
  }

  if (routeName === "fly-anywhere" && isBlackFridayEligible) {
    stage("flights_web_cat_black_friday_index_2025", 4);
  }

  return isBlackFridayExp;
};

export default useBlackFridayExp;
